export default __webpack_public_path__ + "static/media/G_D_btn___gallery_prev.77cc63a4.svg";